import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'lean-data-form',
  templateUrl: './lean-data-form.component.html',
  styleUrls: ['./lean-data-form.component.scss']
})
export class LeanDataFormComponent implements OnInit {

  @ViewChild('ldf_filter', {static : false}) ldf_filter : any;
  
  borderTopColor  = null;
  minHeight       = null;
  @Input()hideAddButton : boolean = false
  @Input()noFilter      : boolean = false;
  @Input()noClose       : boolean = false;
  @Input() title        : string;
  @Input() width        : string ;
  
  @Output() onClose: EventEmitter<boolean> = new EventEmitter();
  @Output() onLoadData: EventEmitter<boolean> = new EventEmitter();
  @Output() onAddNew: EventEmitter<boolean> = new EventEmitter();
  
  constructor(
    protected translate   : TranslateService
  ) { 
    /*
      this.translate.get('global.filter_data',).subscribe((res: any) => {
          this.filter_data      = res.filter_data;
          this.load_data        = res.load_data;
      });
      */
  }

  ngOnInit() {
   // this.showFilter(this.filter.nativeElement);
}


click(e: HTMLDivElement){
   this.loadOrFilter(e);
}


loadOrFilter(e: HTMLDivElement){
  if (this.filterDisplayed){
    this.onLoadData.emit(null);
    this.hideFilter();
  } else {
    this.showFilter(e);
  }
}

  addNew(){
    this.onAddNew.emit(null);
  }
  returnBack(){
    this.onClose.emit(null);
  }

//----------------------------------------------
  filterDisplayed   : boolean = false;
  showFilter(e: HTMLDivElement){     
      e.style.display = 'block';
      this.filterDisplayed = true;
  }

  hideFilter(){
    this.ldf_filter.nativeElement.style.display = 'none';
    this.filterDisplayed = false;
  }
//----------------------------------------------

}
